import { ethers, Wallet } from "ethers";
import getContract from "./contract";
import levelPrices from "./levelPrice";
import getTokenContract from "./tokenContract";
import { getBuso126Contract, getBusoContract } from "./contract";
import getWallet from "./wallet";

export class TransactionService {
  constructor(userId, userAddress) {
    this.userId = userId;
    this.userAddress = userAddress;
  }

  buyLevel = async (level) => {
    try {
      const wallet = await getWallet();

      const tokenContract = await getTokenContract();
      const contract = await getContract();

      const userInfoResponse = await contract.userInfos(this.userId);
      const userLastLevel = ethers.BigNumber.from(userInfoResponse["levelBought"]).toNumber();
      if (userLastLevel+1 < level) {
        throw new Error("User has to buy previous slots first");
      }
      const userBalance = await tokenContract.balanceOf(this.userAddress);
      
      const levelPrice = ethers.utils.parseUnits(levelPrices[level-1].toString(), 18);
      if (userBalance.lt(levelPrice)) {
        throw new Error("User has Insufficient balance");
      }
      
      const allowance = await tokenContract.allowance(this.userAddress, contract.address);
      
      if(allowance.lt(levelPrice)) {
        console.log("userLastLevel: ", userLastLevel);
        const tokenAmount = levelPrice;
        const txn = await tokenContract.approve(contract.address, tokenAmount);
        // const txn = await tokenContract.approve(contract.address, tokenAmount, {gasPrice: ethers.utils.parseUnits('100', 'gwei')});
        await txn.wait();
      }
      
      const transaction = await contract.uplevel(level);
      // const transaction = await contract.upgradeLevel(level, {gasPrice: ethers.utils.parseUnits(wallet.maxFeePerGas.toString(), 'gwei')});
      await transaction.wait();
      return true;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  register = async (refId) => {
    try {
      const wallet = await getWallet();
      const tokenContract = await getTokenContract();
      const contract = await getContract();

      const refAddress = await contract.getAddressById(refId);
      const refInfoResponse = await contract.userInfos(refId);
      const isValidRef = ethers.BigNumber.from(refInfoResponse["id"]).toNumber() > 0;

      if(!isValidRef) {
        throw new Error("Invalid Upline Id. There is no referrer with this id match");
      }

      const id = await contract.getIdByAddress(this.userAddress);
      const isAlreadyRegistered = ethers.BigNumber.from(id).toNumber() > 0;

      if(isAlreadyRegistered) {
        throw new Error("User is already registered");
      }

      const userBalance = await tokenContract.balanceOf(this.userAddress)

      const levelPrice = ethers.utils.parseUnits(levelPrices[0].toString(), 18);
      if (userBalance.lt(levelPrice)) {
        throw new Error("User has Insufficient balance");
      }
      const allowance = await tokenContract.allowance(this.userAddress, contract.address);

      if(allowance.lt(levelPrice)) {
        const tokenAmount = levelPrice;
        const txn = await tokenContract.approve(contract.address, tokenAmount);
        // const txn = await tokenContract.approve(contract.address, tokenAmount, {gasPrice: ethers.utils.parseUnits('100', 'gwei')});
        await txn.wait();
      }
      const transaction = await contract.register(refId);
      // const transaction = await contract.register(refId, {gasPrice: ethers.utils.parseUnits(wallet.maxFeePerGas.toString(), 'gwei')});
      await transaction.wait();
      const userId = ethers.BigNumber.from(await contract.getIdByAddress(this.userAddress)).toNumber();
      return userId;
    } catch (error) {
      throw error;
    }
  }

}